<app-header></app-header>

<div class="responsive">
  <div class="container-fluid">
    <div class="row">

      <!-- Sidebar -->
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>

      <!-- Main Content -->
      <div class="col-md-9">

        <!-- Header + Create Button -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="mb-0">Job Listings</h4>
          <button routerLink="/jobs/create-jobs" class="btn main-backgroundcolor color">
            + Create Job
          </button>
        </div>

        <!-- Skeleton Loader -->
        <div *ngIf="loading" class="row">
          <div class="col-md-6 col-lg-4 mb-4" *ngFor="let item of [1,2,3,4,5,6]">
            <app-card-skelton title="Job"></app-card-skelton>
          </div>
        </div>

        <!-- No Data -->
        <app-no-results-found *ngIf="!loading && jobList.length === 0" title="No Jobs Found">
          <p>No job postings available yet. Create one to get started!</p>
        </app-no-results-found>

        <!-- Job List -->
        <div *ngIf="!loading && jobList.length > 0" class="row g-4">
          <div class="col-md-6 col-lg-4 mb-4" *ngFor="let job of jobList">
            <div class="card job-card h-100 cursor-pointer d-flex flex-column"
                 (click)="openDetailsModal(detailsModal, job)">

              <!-- Card Body -->
              <div class="card-body job-card-body">

                <!-- Company & Role -->
                <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                  <h5 class="mb-0 job-card-company">
                    {{ job.jobPost?.companyName || 'Company' }}
                  </h5>
                  <span class="badge job-role-badge text-white">
                    {{ job.jobPost?.role || 'Role' }}
                  </span>
                </div>

                <!-- Job Title -->
                <h6 class="fw-bold mb-2 job-card-title">
                  {{ job.jobBasics?.title || 'Job Title Not Set' }}
                </h6>

                <!-- Industry & Type -->
                <p class="mb-1 text-muted small job-card-meta">
                  {{ job.jobBasics?.industry || 'Industry' }} •
                  {{ job.jobDetails?.jobType || 'Job Type' }}
                </p>

                <!-- Pay -->
                <p class="fw-bold text-success mb-2 job-card-pay">
                  {{ job.jobDetails?.jobPay ? '₹ ' + job.jobDetails.jobPay : 'Salary Not Disclosed' }}
                </p>

                <!-- Location -->
                <p class="text-muted small mb-2 job-card-location">
                  <i class="bi bi-geo-alt-fill"></i>
                  <ng-container *ngIf="job.jobBasics?.remoteJob === 'Yes'; else locationElse">
                    Remote
                  </ng-container>
                  <ng-template #locationElse>
                    {{ job.jobBasics?.location?.city || job.recruitingAddress?.city || 'Location Not Specified' }},
                    {{ job.jobBasics?.location?.state || job.recruitingAddress?.state || '' }}
                  </ng-template>
                </p>

                <!-- Posted / Expiry -->
                <p class="small text-muted mb-1">
                  Posted: {{ job.createdAt | date:'mediumDate' }}
                </p>
                <p class="small text-muted mb-2" *ngIf="job.activeTill">
                  Apply by: {{ job.activeTill | date:'mediumDate' }}
                </p>

                <!-- Quick Tags -->
                <div class="d-flex flex-wrap gap-2 job-card-tags">
                  <span class="badge bg-light text-dark border">
                    {{ job.jobBasics?.remoteJob }}
                  </span>
                  <ng-container *ngIf="job.applicationSettings?.receiveType; else noApply">
                    <span class="badge bg-light text-dark border">
                      {{ job.applicationSettings.receiveType === 'No Apply' ? 'No Apply' : 'Apply via ' + job.applicationSettings.receiveType }}
                    </span>
                  </ng-container>
                  <ng-template #noApply>
                    <span class="badge bg-light text-dark border">No Apply</span>
                  </ng-template>
                </div>

              </div>

              <!-- Footer -->
              <div class="card-footer job-card-footer bg-light d-flex justify-content-between align-items-center p-2">
                <small class="text-muted btn">
                  <i class="bi bi-clock-history"></i>
                  {{ job.createdAt | date:'short' }}
                </small>

                <button class="btn btn-sm btn-outline-primary btn-primary text-white w-25"
                        type="button"
                        (click)="$event.stopPropagation()"
                        [routerLink]="['/jobs/create-jobs']"
                        [state]="{ job: job }">
                  Edit
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>

<!-- ── Job Details Modal ──────────────────────────────────────────────── -->
<ng-template #detailsModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      {{ selectedJob?.jobBasics?.title || 'Job Details' }}
    </h5>
  </div>

  <div class="modal-body">

    <!-- Company & Role -->
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div>
        <h4 class="mb-1">{{ selectedJob?.jobPost?.companyName }}</h4>
        <h6 class="text-muted mb-0">{{ selectedJob?.jobPost?.role }}</h6>
      </div>
      <span class="badge bg-success fs-6 px-3 py-2">
        {{ selectedJob?.jobDetails?.jobType }}
      </span>
    </div>

    <!-- Salary -->
    <div class="alert alert-success mb-3">
      <h5 class="mb-0">
        <i class="bi bi-currency-rupee"></i>
        {{ selectedJob?.jobDetails?.jobPay || 'Not Disclosed' }}
      </h5>
    </div>

    <!-- Quick Info -->
    <div class="row g-3 mb-4">
      <div class="col-md-4">
        <div class="border p-3 rounded text-center">
          <strong>Industry</strong><br>
          {{ selectedJob?.jobBasics?.industry }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="border p-3 rounded text-center">
          <strong>Remote</strong><br>
          {{ selectedJob?.jobBasics?.remoteJob }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="border p-3 rounded text-center">
          <strong>Apply By</strong><br>
          {{ selectedJob?.activeTill | date:'mediumDate' }}
        </div>
      </div>
    </div>

    <!-- Location -->
    <div class="mb-4">
      <h6><i class="bi bi-geo-alt-fill"></i> Location</h6>
      <p class="mb-1">
        <strong>Google Address:</strong> {{ selectedJob?.jobBasics?.location?.googleAddress || 'N/A' }}
      </p>
      <p class="mb-1">
        {{ selectedJob?.jobBasics?.location?.city }},
        {{ selectedJob?.jobBasics?.location?.state }},
        {{ selectedJob?.jobBasics?.location?.country }}
      </p>
    </div>

    <!-- How to Apply -->
    <div class="mb-4">
      <h6><i class="bi bi-send-fill"></i> How to Apply</h6>
      <p class="fw-bold">
        {{ selectedJob?.applicationSettings?.receiveType }}:
        <span class="text-primary">{{ selectedJob?.applicationSettings?.receiveValue }}</span>
      </p>
      <p *ngIf="selectedJob?.applicationSettings?.documents">
        Required: {{ selectedJob.applicationSettings.documents }}
      </p>
    </div>

    <!-- Job Description -->
    <div class="mb-4">
      <h6><i class="bi bi-file-earmark-text"></i> Duties & Responsibilities</h6>
      <p class="pre-line">{{ selectedJob?.jobDetails?.jobDuties || 'Not provided' }}</p>
    </div>

    <!-- Skills -->
    <div class="mb-4">
      <h6><i class="bi bi-tools"></i> Required Skills</h6>
      <p class="pre-line">{{ selectedJob?.jobDetails?.skills || 'Not specified' }}</p>
    </div>

    <!-- Recruiting Address -->
    <div class="mb-4">
      <h6><i class="bi bi-building"></i> Recruiting Address</h6>
      <p>
        {{ selectedJob?.recruitingAddress?.address }}<br>
        {{ selectedJob?.recruitingAddress?.city }},
        {{ selectedJob?.recruitingAddress?.state }} -
        {{ selectedJob?.recruitingAddress?.postalCode }}<br>
        {{ selectedJob?.recruitingAddress?.country }}
      </p>
      <p *ngIf="selectedJob?.recruitingAddress?.contactNumber">
        Contact: {{ selectedJob.recruitingAddress.contactNumber }}
      </p>
    </div>

    <!-- Posted Info -->
    <div class="text-muted small">
      Posted on: {{ selectedJob?.createdAt | date:'medium' }}<br>
      <span *ngIf="selectedJob?.jobPost?.email">Contact Email: {{ selectedJob.jobPost.email }}</span>
    </div>

  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>